import { render, staticRenderFns } from "./TaskRequestStatusBadge.vue?vue&type=template&id=d221e6aa&scoped=true"
import script from "./TaskRequestStatusBadge.vue?vue&type=script&lang=js"
export * from "./TaskRequestStatusBadge.vue?vue&type=script&lang=js"
import style0 from "./TaskRequestStatusBadge.vue?vue&type=style&index=0&id=d221e6aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d221e6aa",
  null
  
)

export default component.exports